export const environment = {
  production: false,
  baseUrl: 'https://api.ec.purple.lk',
};
